import { c as _c } from "react/compiler-runtime";
import { IcoWarning16 } from '@onefootprint/icons';
import { Form } from '@onefootprint/ui';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { SandboxOutcomeFormData } from '../types';
import useSandboxOutcomeOptions from '../use-sandbox-outcome-options';
const SimulatedOutcomes = () => {
  const $ = _c(18);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "sandboxOutcome.id-doc-outcome.simulated-outcome"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t0);
  const {
    idDocSimulatedOptions
  } = useSandboxOutcomeOptions();
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      name: "idDocOutcome"
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const watchIdDocOutcome = useWatch(t1);
  let t2;
  if ($[2] !== t) {
    t2 = t(_temp);
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <div className="text-body-2 text-tertiary">{t2}</div>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t(_temp2);
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== idDocSimulatedOptions || $[9] !== t4) {
    t5 = <div className="bg-secondary p-2 pl-3 border border-solid rounded border-tertiary"><div className="flex items-center justify-between"><Form.Select name="idDocOutcome" label={t4} size="compact" options={idDocSimulatedOptions} /></div></div>;
    $[8] = idDocSimulatedOptions;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t || $[12] !== watchIdDocOutcome) {
    t6 = watchIdDocOutcome === "fail" && <div className="flex gap-1 items-end"><div><IcoWarning16 color="warning" /></div><div className="text-body-2 text-warning">{t(_temp3)}</div></div>;
    $[11] = t;
    $[12] = watchIdDocOutcome;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t3 || $[15] !== t5 || $[16] !== t6) {
    t7 = <div className="flex flex-col gap-4">{t3}{t5}{t6}</div>;
    $[14] = t3;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};
export default SimulatedOutcomes;
function _temp($) {
  return $.description;
}
function _temp2($_0) {
  return $_0.label;
}
function _temp3($_1) {
  return $_1.options.fail.description;
}